module.exports = __webpack_public_path__ + "img/bottomtrianglepoly.03901258.png";